import { render, staticRenderFns } from "./Prorrogacoes.vue?vue&type=template&id=1a96e06c"
import script from "./Prorrogacoes.vue?vue&type=script&lang=ts"
export * from "./Prorrogacoes.vue?vue&type=script&lang=ts"
import style0 from "./Prorrogacoes.vue?vue&type=style&index=0&id=1a96e06c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports